export default __webpack_public_path__ + "static/media/fNeutral28.a3a8c1b8.png";